import { render, staticRenderFns } from "./WorkspacesModal.vue?vue&type=template&id=de6ab87e"
import script from "./WorkspacesModal.vue?vue&type=script&lang=js"
export * from "./WorkspacesModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspacesModal.vue?vue&type=style&index=0&id=de6ab87e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports